import React, { useContext } from "react";
import { TutorialModal } from "../tutorial-modal";
import {
	CREATE_PROFILE_DATA,
	CREATE_PROFILE_TUTORIAL_SCENARIOS,
} from "../data/create-profile-data";
import { store } from "../../Store";

/**
 * Wrapper del tutorial de crear perfil.
 * Su visibilidad depende del estado global `personalAccountTutorials.createProfileVisible`.
 * @returns {JSX.Element}
 */
export const CreateProfileTutorial = () => {
	const globalState = useContext(store);
	const visible = globalState?.state?.personalAccountTutorials?.createProfileVisible;
	const scenario =
		globalState?.state?.personalAccountTutorials?.createProfileScenario ||
		CREATE_PROFILE_TUTORIAL_SCENARIOS.GUEST;
	const steps = CREATE_PROFILE_DATA.filter((step) => {
		if (!Array.isArray(step?.scenarios) || step.scenarios.length === 0) return true;
		return step.scenarios.includes(scenario);
	});

	/**
	 * Actualiza el flag global de visibilidad del tutorial.
	 * @param {boolean} newVisible
	 */
	const setVisible = (newVisible) => {
		globalState.dispatch({
			type: "CHANGE",
			path: "personalAccountTutorials.createProfileVisible",
			value: newVisible,
		});
	};

	/**
	 * Cierra el tutorial y apaga su flag global.
	 */
	const handleClose = () => {
		setVisible(false);
	};

	return (
		<TutorialModal
			visible={visible}
			setVisible={setVisible}
			onClose={handleClose}
			steps={steps}
			modalId="create-profile-tutorial"
		/>
	);
};
